import type { AppEnv } from '../types/app-env'

const prod = {
	baseUrl: 'https://api.cocoon-space.com',
	v1BaseUrl: 'https://api.cocoon-space.com/v1',
	v3BaseUrl: 'https://api-v2.cocoon-space.com/v3',
}

const preprod = {
	baseUrl: 'https://api-preprod.cocoon-space.dev',
	v1BaseUrl: 'https://api-preprod.cocoon-space.dev/v1',
	v3BaseUrl: 'https://api-preprod-v2.cocoon-space.dev/v3',
}

const configs = {
	development: preprod,
	preprod,
	prod,
} as const

export const getApiConfig = (env: AppEnv) => configs[env] ?? configs.prod
